import React from 'react';
import { useNavigate } from 'react-router-dom';

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      <h1>Welcome to NestLinker!</h1>
      <p>Your one-stop solution for managing devices.</p>
      <button
        style={{
          padding: '0.5rem 1rem',
          fontSize: '1rem',
          marginTop: '1rem',
          cursor: 'pointer',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '0.5rem',
        }}
        onClick={() => navigate('/login')}
      >
        Go to Login
      </button>
    </div>
  );
}

export default LandingPage;